// extracted by mini-css-extract-plugin
module.exports = {"form":"CreateAccount_form__1x49j","container":"CreateAccount_container__1JzIr"};